import { StaffAvailabilityDto } from "types/staff"
import { deleteApiRequest, postApiRequest, putApiRequest } from "utils/fetch-helper"

export async function createStaffAvailability(staff_availability_dto: StaffAvailabilityDto) {
    let api_output = await postApiRequest(
        `/v1/staff/availability`,
        staff_availability_dto
    )
    return api_output
}


export async function updateStaffAvailability(staff_availability_dto: StaffAvailabilityDto) {
    let api_output = await putApiRequest(
        `/v1/staff/availability/${staff_availability_dto.id}`,
        staff_availability_dto
    )
    return api_output
}

export async function expireStaffAvailability(staff_availability_dto: StaffAvailabilityDto, expiry: string) {
    let api_output = await deleteApiRequest(
        `/v1/staff/availability/${staff_availability_dto.id}`
    )
    if (!api_output.ok) {
        staff_availability_dto.expiryDate = expiry
        api_output = await putApiRequest(
            `/v1/staff/availability/${staff_availability_dto.id}`,
            staff_availability_dto
        )
    }
    return api_output
}
